import { useState } from 'react';
import './ElementStepperHeader.scss';
import { LanguageTranslate } from '../Infraestructure/LanguageTranslate';

interface IStepper {
    data: { label: string; description?: string; }[];
    fullData?: { label: string; description?: string; }[];
    className?: string;
    ocult?: boolean;
    onChange: (currentStep: number) => any;
    stepPosition: number;
    stepNumberStart?: number;
}

const ElementStepperHeader = (props: IStepper) => {
    const languageTranslate = LanguageTranslate();
    const [expanded, setExpanded] = useState(false);

    if (props.data.length === 0 || props.ocult) return <div></div>;

    const canExpand = !!props.fullData && props.fullData.length > props.data.length;
    const isExpanded = expanded && canExpand;
    const displayData = isExpanded ? (props.fullData as { label: string; description?: string; }[]) : props.data;
    const displayStepPosition = isExpanded ? (props.stepNumberStart || 0) + props.stepPosition : props.stepPosition;
    const displayStepNumberStart = isExpanded ? 0 : (props.stepNumberStart || 0);

    return (
        <div className={`ElementStepperHeader ${props.className ? props.className : ''}`}>
            <div className='ElementStepperHeader-card'>
                <div className='ElementStepperHeader-header'>
                    <span className='ElementStepperHeader-title'>{languageTranslate.textoFlujoAprobacion}</span>
                    {
                        canExpand &&
                        <button type='button' className='ElementStepperHeader-toggle' onClick={() => setExpanded(prev => !prev)}>
                            <i className={`fa-solid ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                        </button>
                    }
                </div>
                {
                    displayData.map((row, index) => {
                        const stepNumber = displayStepNumberStart + index + 1;
                        const isComplete = stepNumber < displayStepPosition;
                        const isCurrentStep = stepNumber === displayStepPosition;
                        const isLastStep = index === displayData.length - 1;
                        const statusKey = isComplete ? 'completed' : isCurrentStep ? 'current' : 'pending';
                        const statusText = isComplete ? languageTranslate.textoFlujoCompletado : isCurrentStep ? languageTranslate.textoFlujoEnCurso : languageTranslate.textoFlujoPendiente;

                        return (
                            <div key={index} className={`ElementStepperHeader-row status-${statusKey}`} onClick={() => props.onChange(stepNumber)}>
                                <div className='ElementStepperHeader-track'>
                                    <div className='ElementStepperHeader-circle'>
                                        <i className={`fa-solid ${isComplete ? 'fa-check' : 'fa-user'}`} />
                                    </div>
                                    { !isLastStep && <div className='ElementStepperHeader-line' /> }
                                </div>
                                <div className='ElementStepperHeader-info'>
                                    <span className='ElementStepperHeader-label'>{row.label}</span>
                                    { row.description ? <span className='ElementStepperHeader-description'>{row.description}</span> : null }
                                </div>
                                <span className='ElementStepperHeader-status'>{statusText}</span>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default ElementStepperHeader;
